// extracted by mini-css-extract-plugin
var _1 = "AddressOption_address__Vq47l";
var _2 = "AddressOption_container__5bFxt";
var _3 = "AddressOption_selected__gTfq5";
var _4 = "AddressOption_suggested__-JBZH";
var _5 = "AddressOption_title__VVjL1";
export { _1 as "address", _2 as "container", _3 as "selected", _4 as "suggested", _5 as "title" }
